/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingOrganizationTemplateModel } from '../../models/onboarding-organization-template-model';

export interface ConsumerOnboardingOrganizationTemplatesGet$Params {
}

export function consumerOnboardingOrganizationTemplatesGet(http: HttpClient, rootUrl: string, params?: ConsumerOnboardingOrganizationTemplatesGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OnboardingOrganizationTemplateModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerOnboardingOrganizationTemplatesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OnboardingOrganizationTemplateModel>>;
    })
  );
}

consumerOnboardingOrganizationTemplatesGet.PATH = '/Consumer/OnboardingOrganizationTemplates';
